import {
  GET_LABREQUESTREPORT_FAIL,
  GET_LABREQUESTREPORT_SUCCESS,
  GET_LABREQUESTREPORTS_FAIL,
  GET_LABREQUESTREPORTS_SUCCESS,
  ADD_LABREQUESTREPORT_SUCCESS,
  ADD_LABREQUESTREPORT_FAIL,
  UPDATE_LABREQUESTREPORT_SUCCESS,
  UPDATE_LABREQUESTREPORT_FAIL,
  DELETE_LABREQUESTREPORT_SUCCESS,
  DELETE_LABREQUESTREPORT_FAIL,  
  SET_STATE_LABREQUESTREPORT
} from "./actionTypes";

const INIT_STATE = {
  labRequestReports: [],
  labRequestReport: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestReports = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTREPORTS_SUCCESS:
      return {
        ...state,
        labRequestReports: action.payload.labRequestReports,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTREPORT:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTREPORTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTREPORT_SUCCESS:
      return {
        ...state,
        labRequestReports: [...state.labRequestReports, action.payload],
      };

    case ADD_LABREQUESTREPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTREPORT_SUCCESS:
      return {
        ...state,
        labRequestReports: state.labRequestReports.map(labRequestReport =>
          labRequestReport.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestReport }
            : labRequestReport
        ),
      };

    case UPDATE_LABREQUESTREPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTREPORT_SUCCESS:
      return {
        ...state,
        labRequestReports: state.labRequestReports.filter(
          labRequestReport => labRequestReport.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTREPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTREPORT_SUCCESS:
      return {
        ...state,
        labRequestReport: action.payload,
      };

    case GET_LABREQUESTREPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestReports;
